// extracted by mini-css-extract-plugin
export default {"slideImage":"_68HUCTF65wCMUXOyjN9WZm","slideImageLoading":"_6tOfeTjAOkCU18Q9U2eEmc _68HUCTF65wCMUXOyjN9WZm","placeholder":"kK2dhtzUckskEMNnJR98Q"};